// third-party
import { createSlice } from '@reduxjs/toolkit';

// types
import { DefaultRootStateProps } from 'types';
import axiosDomain from "../../utils/axios/axiosDomain";
import { dispatch } from "../index";
import { SysGroup } from "../../types/type/sys-users-types";

// ----------------------------------------------------------------------

const initialState: DefaultRootStateProps['sysGroup'] = {
    error: null,
    sysGroup: [],
};

const sysGroup = createSlice({
    name: 'sysGroup',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        //GET ALL SYS GROUP
        getAllSysGroup(state, action) {
            state.sysGroup = action.payload;
        },

        //INSERT NEW SYS GROUP
        insertNewSysGroup(state, action) {
            state.sysGroup.push(action.payload);
        },

        //UPDATE SYS GROUP
        updateSysGroup(state, action) {
            state.sysGroup = state.sysGroup.filter((el: SysGroup) => {
                if (el.id == action.payload.id) {
                    el = action.payload
                }
                return el
            })
        },

        //DELETE SYS GROUP
        deleteSysGroup(state, action) {
            state.sysGroup = state.sysGroup.filter((el: SysGroup) => el.id != action.payload);
        },
    }
});

// Reducer
export default sysGroup.reducer;

// ----------------------------------------------------------------------

export function getAllSysGroup() {
    return async () => {
        try {
            const response = await axiosDomain.get('/sysgroups');
            if (response.data.status == 'OK') {
                dispatch(sysGroup.actions.getAllSysGroup(response.data.result));
            } else {
                dispatch(sysGroup.actions.hasError(response.data.message))
            }
        } catch (error) {
            dispatch(sysGroup.actions.hasError(error));
        }
    };
}

export function addSysGroup(sysGroupBody: SysGroup) {
    return async () => {
        try {
            const response = await axiosDomain.post('/sysgroups/add', sysGroupBody);
            if (response.data.status == 'OK') {
                dispatch(sysGroup.actions.insertNewSysGroup(response.data.result));
            } else {
                dispatch(sysGroup.actions.hasError(response.data.message))
            }
        } catch (error) {
            dispatch(sysGroup.actions.hasError(error));
        }
    };
}

export function updateSysGroup(groupId: String | undefined, sysGroupBody: SysGroup) {
    return async () => {
        try {
            const response = await axiosDomain.put('/sysgroups/' + groupId, sysGroupBody);
            if (response.data.status == 'OK') {
                dispatch(sysGroup.actions.updateSysGroup(response.data.result));
            } else {
                dispatch(sysGroup.actions.hasError(response.data.message))
            }
        } catch (error) {
            dispatch(sysGroup.actions.hasError(error));
        }
    };
}

export function deleteSysGroup(groupId: String | undefined) {
    return async () => {
        try {
            const response = await axiosDomain.delete('/sysgroups/' + groupId);

            if (response.data.status == 'OK') {
                dispatch(sysGroup.actions.deleteSysGroup(groupId));
            } else {
                dispatch(sysGroup.actions.hasError(response.data.message))
            }
        } catch (error) {
            dispatch(sysGroup.actions.hasError(error));
        }
    };
}